/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import {put, takeLatest, takeEvery } from '@redux-saga/core/effects';
import { setThemeUiSuccess, setThemeUiFailure } from '../actions/ui.action';
import { LocalStorageRepository } from '../../repositories/local-storage.repository';
import { SET_UI_THEME, SetUiTheme } from '../../types/ui-action.type';

function* onSetTheme(themeData:SetUiTheme) {
  try {
    yield put(setThemeUiSuccess(themeData.payload));
    LocalStorageRepository.setUiTheme(themeData.payload);
  } catch (err) {
    console.log("Fail Setting Theme");
    yield put(setThemeUiFailure(err));
  }
}

export function* watchOnSetTheme() {
  yield takeLatest(SET_UI_THEME, onSetTheme);
}
